/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ColumbusPlannerFlightRoutesModel,
  ColumbusPlannerTermModel,
  GetColumbusTreeParams,
  GetColumbusTreeResponse,
  LoadColumbusPlannerResponse,
  SaveColumbusPlannerSettingsRequest,
  SaveTimeLineRequest,
  SaveTimeLineResponse
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const loadColumbusPlanner = (
    productId: number,
    termsSerialId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LoadColumbusPlannerResponse>(
      {url: `/api/columbus-planner/planner/${productId}/${termsSerialId}`, method: 'GET', signal
    },
      );
    }
  



export const getLoadColumbusPlannerQueryKey = (productId?: number,
    termsSerialId?: number,) => {
    return [
    `/api/columbus-planner/planner/${productId}/${termsSerialId}`
    ] as const;
    }

    
export const getLoadColumbusPlannerQueryOptions = <TData = Awaited<ReturnType<typeof loadColumbusPlanner>>, TError = ErrorType<unknown>>(productId: number,
    termsSerialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlanner>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoadColumbusPlannerQueryKey(productId,termsSerialId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loadColumbusPlanner>>> = ({ signal }) => loadColumbusPlanner(productId,termsSerialId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && termsSerialId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlanner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LoadColumbusPlannerQueryResult = NonNullable<Awaited<ReturnType<typeof loadColumbusPlanner>>>
export type LoadColumbusPlannerQueryError = ErrorType<unknown>


export function useLoadColumbusPlanner<TData = Awaited<ReturnType<typeof loadColumbusPlanner>>, TError = ErrorType<unknown>>(
 productId: number,
    termsSerialId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlanner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadColumbusPlanner>>,
          TError,
          Awaited<ReturnType<typeof loadColumbusPlanner>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoadColumbusPlanner<TData = Awaited<ReturnType<typeof loadColumbusPlanner>>, TError = ErrorType<unknown>>(
 productId: number,
    termsSerialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlanner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadColumbusPlanner>>,
          TError,
          Awaited<ReturnType<typeof loadColumbusPlanner>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoadColumbusPlanner<TData = Awaited<ReturnType<typeof loadColumbusPlanner>>, TError = ErrorType<unknown>>(
 productId: number,
    termsSerialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlanner>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLoadColumbusPlanner<TData = Awaited<ReturnType<typeof loadColumbusPlanner>>, TError = ErrorType<unknown>>(
 productId: number,
    termsSerialId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlanner>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoadColumbusPlannerQueryOptions(productId,termsSerialId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const saveColumbusPlannerSettings = (
    saveColumbusPlannerSettingsRequest: SaveColumbusPlannerSettingsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/columbus-planner/settings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveColumbusPlannerSettingsRequest, signal
    },
      );
    }
  


export const getSaveColumbusPlannerSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveColumbusPlannerSettings>>, TError,{data: SaveColumbusPlannerSettingsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveColumbusPlannerSettings>>, TError,{data: SaveColumbusPlannerSettingsRequest}, TContext> => {

const mutationKey = ['saveColumbusPlannerSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveColumbusPlannerSettings>>, {data: SaveColumbusPlannerSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  saveColumbusPlannerSettings(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveColumbusPlannerSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof saveColumbusPlannerSettings>>>
    export type SaveColumbusPlannerSettingsMutationBody = SaveColumbusPlannerSettingsRequest
    export type SaveColumbusPlannerSettingsMutationError = ErrorType<unknown>

    export const useSaveColumbusPlannerSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveColumbusPlannerSettings>>, TError,{data: SaveColumbusPlannerSettingsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveColumbusPlannerSettings>>,
        TError,
        {data: SaveColumbusPlannerSettingsRequest},
        TContext
      > => {

      const mutationOptions = getSaveColumbusPlannerSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const loadColumbusPlannerTerm = (
    termId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ColumbusPlannerTermModel>(
      {url: `/api/columbus-planner/term/${termId}`, method: 'GET', signal
    },
      );
    }
  



export const getLoadColumbusPlannerTermQueryKey = (termId?: number,) => {
    return [
    `/api/columbus-planner/term/${termId}`
    ] as const;
    }

    
export const getLoadColumbusPlannerTermQueryOptions = <TData = Awaited<ReturnType<typeof loadColumbusPlannerTerm>>, TError = ErrorType<unknown>>(termId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTerm>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoadColumbusPlannerTermQueryKey(termId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loadColumbusPlannerTerm>>> = ({ signal }) => loadColumbusPlannerTerm(termId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(termId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTerm>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LoadColumbusPlannerTermQueryResult = NonNullable<Awaited<ReturnType<typeof loadColumbusPlannerTerm>>>
export type LoadColumbusPlannerTermQueryError = ErrorType<unknown>


export function useLoadColumbusPlannerTerm<TData = Awaited<ReturnType<typeof loadColumbusPlannerTerm>>, TError = ErrorType<unknown>>(
 termId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTerm>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadColumbusPlannerTerm>>,
          TError,
          Awaited<ReturnType<typeof loadColumbusPlannerTerm>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoadColumbusPlannerTerm<TData = Awaited<ReturnType<typeof loadColumbusPlannerTerm>>, TError = ErrorType<unknown>>(
 termId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTerm>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadColumbusPlannerTerm>>,
          TError,
          Awaited<ReturnType<typeof loadColumbusPlannerTerm>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoadColumbusPlannerTerm<TData = Awaited<ReturnType<typeof loadColumbusPlannerTerm>>, TError = ErrorType<unknown>>(
 termId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTerm>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLoadColumbusPlannerTerm<TData = Awaited<ReturnType<typeof loadColumbusPlannerTerm>>, TError = ErrorType<unknown>>(
 termId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTerm>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoadColumbusPlannerTermQueryOptions(termId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const loadColumbusPlannerTermFlightRoutes = (
    termId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ColumbusPlannerFlightRoutesModel>(
      {url: `/api/columbus-planner/term/${termId}/flight-routes`, method: 'GET', signal
    },
      );
    }
  



export const getLoadColumbusPlannerTermFlightRoutesQueryKey = (termId?: number,) => {
    return [
    `/api/columbus-planner/term/${termId}/flight-routes`
    ] as const;
    }

    
export const getLoadColumbusPlannerTermFlightRoutesQueryOptions = <TData = Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>, TError = ErrorType<unknown>>(termId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoadColumbusPlannerTermFlightRoutesQueryKey(termId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>> = ({ signal }) => loadColumbusPlannerTermFlightRoutes(termId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(termId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LoadColumbusPlannerTermFlightRoutesQueryResult = NonNullable<Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>>
export type LoadColumbusPlannerTermFlightRoutesQueryError = ErrorType<unknown>


export function useLoadColumbusPlannerTermFlightRoutes<TData = Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>, TError = ErrorType<unknown>>(
 termId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>,
          TError,
          Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoadColumbusPlannerTermFlightRoutes<TData = Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>, TError = ErrorType<unknown>>(
 termId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>,
          TError,
          Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoadColumbusPlannerTermFlightRoutes<TData = Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>, TError = ErrorType<unknown>>(
 termId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLoadColumbusPlannerTermFlightRoutes<TData = Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>, TError = ErrorType<unknown>>(
 termId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadColumbusPlannerTermFlightRoutes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoadColumbusPlannerTermFlightRoutesQueryOptions(termId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const saveColumbusTimeLine = (
    saveTimeLineRequest: SaveTimeLineRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SaveTimeLineResponse>(
      {url: `/api/columbus-planner/timeline`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveTimeLineRequest, signal
    },
      );
    }
  


export const getSaveColumbusTimeLineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveColumbusTimeLine>>, TError,{data: SaveTimeLineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveColumbusTimeLine>>, TError,{data: SaveTimeLineRequest}, TContext> => {

const mutationKey = ['saveColumbusTimeLine'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveColumbusTimeLine>>, {data: SaveTimeLineRequest}> = (props) => {
          const {data} = props ?? {};

          return  saveColumbusTimeLine(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveColumbusTimeLineMutationResult = NonNullable<Awaited<ReturnType<typeof saveColumbusTimeLine>>>
    export type SaveColumbusTimeLineMutationBody = SaveTimeLineRequest
    export type SaveColumbusTimeLineMutationError = ErrorType<unknown>

    export const useSaveColumbusTimeLine = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveColumbusTimeLine>>, TError,{data: SaveTimeLineRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveColumbusTimeLine>>,
        TError,
        {data: SaveTimeLineRequest},
        TContext
      > => {

      const mutationOptions = getSaveColumbusTimeLineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getColumbusTree = (
    params?: GetColumbusTreeParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetColumbusTreeResponse>(
      {url: `/api/columbus-planner/tree`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetColumbusTreeQueryKey = (params?: GetColumbusTreeParams,) => {
    return [
    `/api/columbus-planner/tree`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetColumbusTreeQueryOptions = <TData = Awaited<ReturnType<typeof getColumbusTree>>, TError = ErrorType<unknown>>(params?: GetColumbusTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColumbusTree>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetColumbusTreeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getColumbusTree>>> = ({ signal }) => getColumbusTree(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getColumbusTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetColumbusTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getColumbusTree>>>
export type GetColumbusTreeQueryError = ErrorType<unknown>


export function useGetColumbusTree<TData = Awaited<ReturnType<typeof getColumbusTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetColumbusTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColumbusTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getColumbusTree>>,
          TError,
          Awaited<ReturnType<typeof getColumbusTree>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetColumbusTree<TData = Awaited<ReturnType<typeof getColumbusTree>>, TError = ErrorType<unknown>>(
 params?: GetColumbusTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColumbusTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getColumbusTree>>,
          TError,
          Awaited<ReturnType<typeof getColumbusTree>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetColumbusTree<TData = Awaited<ReturnType<typeof getColumbusTree>>, TError = ErrorType<unknown>>(
 params?: GetColumbusTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColumbusTree>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetColumbusTree<TData = Awaited<ReturnType<typeof getColumbusTree>>, TError = ErrorType<unknown>>(
 params?: GetColumbusTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColumbusTree>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetColumbusTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




